module.exports = __webpack_public_path__ + "img/banner-4.da12335b.png";